import { EuiIcon } from "@inscopix/ideas-eui";
import { colorsByRunStatus } from "types/ColorsByRunStatus";
// import { useModalContext } from "providers/ModalProvider/ModalProvider";
import { includes } from "lodash";
import { DATA_TABLE_TOOLTIP_ID } from "pages/gdt/layout/DataTableTooltip";
import { ModelSchema } from "api/client/types/DjangoClient.types";
import { RunStatus } from "types/constants";

interface RunStatusAndLogIconProps {
  runId: ModelSchema["RunSchema"]["id"];
  runStatus: ModelSchema["RunSchema"]["status"];
  runCreated: ModelSchema["RunSchema"]["dateCreated"];
}

export const RunStatusIcon = ({
  runId,
  runStatus,
  runCreated,
}: RunStatusAndLogIconProps) => {
  const color = colorsByRunStatus[runStatus];
  const RunStatusName = RunStatus[runStatus];
  const showTaskLog = includes(
    [RunStatus["COMPLETE"], RunStatus["FAILED"]],
    runStatus,
  );
  // const { openModal, closeModal } = useModalContext();

  /**
   *
   * TODO RUN LOGS
   */
  const showModal = () => undefined;
  // openModal(
  //   <ModalTaskLogs
  //     task={{ id: taskId, status: RunStatus, dateCreated: taskCreated }}
  //     onClose={closeModal}
  //   />,
  // );

  const tooltipHtml = `<span style="color:${color}">${RunStatusName}</span>${
    showTaskLog ? `<br />View task logs` : ""
  }`;

  return (
    <EuiIcon
      data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
      data-tooltip-html={tooltipHtml}
      data-test-id={`task-status-icon-${RunStatus[runStatus]}`}
      aria-label="View task logs"
      type="stopFilled"
      size="l"
      color={color}
      onClick={() => showTaskLog && showModal()}
      style={{ cursor: showTaskLog ? "pointer" : "default" }}
    />
  );
};
